"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledMessageContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledMessageContainer = styled_components_1.default.div `
  align-items: center;
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 515px;
  justify-content: center;
  max-height: ${({ height }) => (height ? height : '550px')};
`;
